<template>
  <div id="header">
    <div class="header">
      <div id="logoTopo">
        <div class="btnMenuTopo">
          <v-icon
          v-if="$verificaPerfilHabilitador() || $verificaPerfilCadastrador() || ($getStatusSolicitacao() != 1 && 
            $getStatusSolicitacao() != null) || $getStatusSIMPAS() != null"
            @click.stop="$store.commit('setOpenMenu', !$store.getters.openMenu)"
          >menu
          </v-icon>
      <v-flex class="left">
          <v-img
            @click='logout()'
            style="width:350px;"
            min-height="15"
            min-width="121"          
            max-height="50"
            max-width="404"
            src="/images/BANNER-CAF_DIGITAL.jpg"
          ></v-img>
      </v-flex>
        </div>
          <img  @click='redirecionamentoPaginaCaf()' src="/images/logoTopo.png" alt="logotipo Comprasnet.ba"/>
      </div>
    <div>
    </div>
      <div v-show="btnAcessoRestrito && redeGoverno">
        <div v-if="displayAmbiente" class="btnsTopo left maior" style="width:50%;top:15px;color:red;">
          <strong>Ambiente: Localhost</strong><br>
          <strong>Banco: {{conexaoNomeBd}} ({{conexaoIpBD}}) </strong>
        </div>

        <div class="btnsTopo right maior">
          <v-btn color="info" small outline @click="acessoRestrito()"
            >Acesso Restrito
            <v-icon right>lock</v-icon>
          </v-btn>
        </div>
        <div class="btnsTopo right menor">
          <v-btn flat fab color="info" small @click="acessoRestrito()">
            <v-icon large>lock</v-icon>
          </v-btn>
        </div>
      </div>
      <div v-show="btnLogout">
        <div v-if="displayAmbiente" class="btnsTopo left maior" style="width:40%;top:15px;color:red;">
          <strong>Ambiente: Localhost</strong><br> 
          <strong>Banco: {{conexaoNomeBd}} ({{conexaoIpBD}}) </strong>
        </div>
        
        <div class="btnsTopo right maior">
          <v-btn color="info" small outline @click="logout()"
            >Sair
            <v-icon right>power_settings_new</v-icon>
          </v-btn>
        </div>
        <div class="btnsTopo right menor">
          <v-btn flat fab color="info" small @click="logout()">
            <v-icon large>power_settings_new</v-icon>
          </v-btn>
        </div>
      </div>
      <preload />
    </div>
  
    <menuRestrito
  v-if="deveExibirMenuRestrito"
  :drawer="$store.getters.openMenu"
/>
  </div>
</template>

<script>
import preload from "./preload";
import menuRestrito from "./menuRestrito";
import loginService from "../services/loginService";
import Vue from 'vue';

export default {
  name: "topo",
  components: {
    /*Componentes utilizados*/ preload,
    menuRestrito,
  },
  props: {
    //Propriedades que o objeto recebe como parametro
    btnLogout: Boolean,
    btnAcessoRestrito: Boolean,
  },
  data() {
    //Declaracao de variaveis
    return {
      redeGoverno: false,
      drawer: false,
      displayAmbiente: false,
      conexaoIpBD: "",
      conexaoNomeBd: "",
    };
  },
  created() /*Metodo de start do componente*/ {
     console.log("Status Solicitação no componente:", this.$store.getters.getStatusSolicitacao);
    this.getRedeGoverno();
    this.getAmbienteBD();
  },
  computed: {
      statusSolicitacao() {
        return this.$store.getters.getStatusSolicitacao;
      },
      statusSIMPAS() {
        return this.$store.getters.getStatusSIMPAS;
      },
      deveExibirMenuRestrito() {
        return (
          this.$verificaPerfilHabilitador() ||
          this.$verificaPerfilCadastrador() ||
          this.statusSolicitacao != null ||
          this.statusSIMPAS != null
        );
      }
    },
  methods: {
    //Declaracao de todos os metodos
    logout() {
      this.$router.push("/login");
    },
    acessoRestrito() {
      this.$router.push("/loginrestrito");
    },
    getRedeGoverno() {
      loginService.getRedeGoverno().then((response) => {
        /*resposta do servico*/
        this.redeGoverno = response.data; /*dados de retorno*/
      });
    },
    redirecionamentoPaginaCaf(){
      window.open("https://www.comprasnet.ba.gov.br/");
    },
    getAmbienteBD(){
      /*Verifica configurações do backend e exibe na tela*/
        let urlTeste = Vue.prototype.$baseURL;
        if(urlTeste.match("localhost")){
           loginService.getAmbienteBd().then((response) => {
            this.displayAmbiente = true;
            this.conexaoIpBD = response.data.ipBD,
            this.conexaoNomeBd = response.data.nomeBD
          });
     
        }
        this.displayAmbiente = false;
      }
  },
};
</script>

